import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container, Button } from 'reactstrap';

import Page from '../../components/Layout/Page/Page';
import RoundedButton from '../../components/Buttons/RoundedButton/RoundedButton';
import TrackWave from '../../components/Tracks/TrackWave/TrackWave';
import TrackRow from '../../components/Tracks/TrackRow/TrackRow';
import Loader from '../../components/Common/Loader';
import CommentTrackModal from '../../components/Modals/Tracks/CommentTrackModal';
import VoteTrackModal from '../../components/Modals/Tracks/VoteTrackModal';
import SaveTrackModal from '../../components/Modals/Tracks/SaveTrackModal';
import RewardTrackModal from '../../components/Modals/Tracks/RewardTrackModal';
import PlayButton from '../../components/Buttons/PlayButton/PlayButton';

import { ReactComponent as RewardsIcon } from '../../assets/images/reward.svg';
import { ReactComponent as CheckedIcon } from '../../assets/images/checkbox-checked.svg';
import { ReactComponent as UncheckedIcon } from '../../assets/images/checkbox.svg';

import { loadAllTracks, loadTrackComments, updateTrackPublic } from '../../helpers/api/tracks.api';

import { play, pause, select } from '../../store/actions';

import './Tracks.scss';

const Tracks = props => {
    const [loading, setLoading] = useState(true);
    const [tracks, setTracks] = useState([]);

    const [track, setTrack] = useState([]);
    const [trackComments, setTrackComments] = useState([]);

    const [time, setTime] = useState(null);

    const [makingAction, setMakingAction] = useState('');

    useEffect(() => {
        setLoading(true);
        loadAllTracks()
            .then((result) => {
                if (result.success) {
                    setTracks(result.tracks);
                    setTrack(result.tracks[0]);
                } else {
                    console.log(result.message);
                    setTracks([]);
                    setTrack(null);
                }
                setLoading(false);
            })
            .catch((error) => {
                setTracks([]);
                setTrack(null);
                setLoading(false);
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (tracks && tracks[0] && !track)
            setTrack(tracks[0]);
    }, [tracks]);

    useEffect(() => {
        if (track) loadComments();
    }, [track]);

    useEffect(() => {
        setTrack(props.player.track);
    }, [props.player.track]);

    function loadComments() {
        if (track._id)
            loadTrackComments(track._id)
                .then((result) => {
                    if (result.success) {
                        setTrackComments(result.comments);
                    } else {
                        console.log(result.message);
                        setTrackComments([]);
                    }
                })
                .catch((error) => {
                    setTrackComments([]);
                    console.log(error);
                });
    }

    function handleOnPublicCheckboxClick() {
        let newStatus = !track.public;
        setTrack({
            ...track,
            public: newStatus
        })

        updateTrackPublic(track._id, newStatus)
            .then((result) => {
                if (!result.success) {
                    setTrack({
                        ...track,
                        public: !newStatus
                    })
                }
            })
            .catch((error) => {
                setTrack({
                    ...track,
                    public: !newStatus
                })
                console.log(error);
            });
    }

    return <Page className="tracks">
        <Container fluid className="h-100 d-flex flex-column">
            <Row className="pb-3">
                <Col className="h-100 d-flex flex-column justify-content-between">
                    {loading ?
                        <Loader />
                        : track ?
                            <>
                                <Row>
                                    <Col sm="8" className="d-flex align-items-center">
                                        <div className="d-flex flex-column mr-5">
                                            {props.user._id === track.author._id &&
                                                <h6><i>I tuoi brani</i></h6>}
                                            <h4 className="mb-0">{track.title}</h4>
                                            {props.user._id !== track.author._id && <h6>{track.author.name}</h6>}
                                        </div>
                                        {/* <PlayButton playing={playing} onClick={() => setPlaying(!playing)} /> */}
                                        <PlayButton playing={props.player.playing} onClick={() => !props.player.playing ? props.play() : props.pause()} />
                                        {props.user._id === track.author._id && <div className="d-none d-lg-flex align-items-end justify-content-end h-100 ml-4">
                                            <label className="mr-2 mb-0">
                                                Brano visibile sul tuo profilo
                                            </label>
                                            <Button
                                                className="public-checkbox"
                                                color="link"
                                                onClick={handleOnPublicCheckboxClick}>
                                                {track.public ?
                                                    <CheckedIcon />
                                                    :
                                                    <UncheckedIcon />}
                                            </Button>
                                        </div>}
                                    </Col>
                                    <Col sm="4" className="d-none d-lg-flex align-items-center justify-content-end">
                                        {props.user._id === track.author._id ?
                                            <div className="d-flex justify-content-end">
                                                <p className="track-points">
                                                    {track.points || 0}
                                                    {' punti'}
                                                </p>
                                                <p className="track-rewards">
                                                    <RewardsIcon />
                                                    {track.rewards ? track.rewards.length : 0}
                                                    {' Rewards'}
                                                </p>
                                            </div>
                                            :
                                            <RoundedButton color="primary" className="px-3" onClick={() => props.history.push('/users/' + track.author._id)}>VISUALIZZA Profilo</RoundedButton>}
                                    </Col>
                                </Row>
                                <div className="wave-wrapper pt-lg-5 pb-0">
                                    <TrackWave audioFile={track.file.url} comments={trackComments} playing={props.player.playing} onLoading={() => setTime(0)} onReady={() => setTime(0)} onPlaying={(milliseconds) => setTime(milliseconds)} />
                                </div>
                                <Row>

                                    {props.user.type === 'artist' && <Col className="d-flex d-lg-none align-items-center justify-content-start">
                                        {props.user._id === track.author._id ?
                                            <div className="d-flex justify-content-end">
                                                <p className="track-points">
                                                    {track.points || 0}
                                                    {' punti'}
                                                </p>
                                                <p className="track-rewards">
                                                    <RewardsIcon />
                                                    {track.rewards ? track.rewards.length : 0}
                                                    {' Rewards'}
                                                </p>
                                            </div>
                                            :
                                            <RoundedButton color="primary" className="px-3" onClick={() => props.history.push('/users/' + track.author._id)}>VISUALIZZA Profilo</RoundedButton>}
                                    </Col>}
                                </Row>
                                {props.user.type === 'scout' &&
                                    <Row>
                                        <Col xs="6" lg="3">
                                            <RoundedButton onClick={() => setMakingAction('comment')} className="px-lg-5 w-100 mb-4">COMMENTA</RoundedButton>
                                        </Col>
                                        <Col xs="6" lg="3">
                                            <RoundedButton onClick={() => setMakingAction('vote')} className="px-lg-5 w-100 mb-4" disabled={track.votings.length >= 5}>ASSEGNA VOTO</RoundedButton>
                                        </Col>
                                        <Col xs="6" lg="3">
                                            <RoundedButton onClick={() => setMakingAction('save')} className="px-lg-5 w-100 mb-4">SALVA</RoundedButton>
                                        </Col>
                                        <Col xs="6" lg="3">
                                            <RoundedButton onClick={() => setMakingAction('reward')} className="px-lg-5 w-100 mb-4">REWARD</RoundedButton>
                                        </Col>
                                    </Row>}
                                <CommentTrackModal isOpen={makingAction === 'comment'} track={track} time={time} onClose={() => setMakingAction('')} onSuccess={() => loadComments()} />
                                <VoteTrackModal isOpen={makingAction === 'vote'} track={track} onClose={() => setMakingAction('')} />
                                <SaveTrackModal isOpen={makingAction === 'save'} track={track} onClose={() => setMakingAction('')} />
                                <RewardTrackModal isOpen={makingAction === 'reward'} track={track} onClose={() => setMakingAction('')} />
                            </> : null}
                </Col>
            </Row>

            <Row className="pt-3">
                <Col className="h-100">
                    <ul className="tracks-list h-100">
                        {tracks.map(t => <TrackRow key={t._id} track={t} onPlayClick={() => {
                            props.pause();
                            props.select(t);
                        }} />)}
                    </ul>
                </Col>
            </Row>

        </Container>
    </Page>;
}

const mapStatetoProps = (state) => {
    return {
        user: state.Auth.user,
        player: state.Player
    };
};

const mapDispatchToProps = {
    play, pause, select
}

export default connect(mapStatetoProps, mapDispatchToProps)(Tracks);